import { Link } from "react-router-dom";
import { ArrowRight, Clock, Mail, MapPin, Phone } from "lucide-react";
import { EMAIL, EMAIL_HREF, PHONE, PHONE_HREF } from "../../lib/site";

export default function ContactSection() {
  return (
    <section id="contact" className="relative overflow-hidden bg-[#0A1128] py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Contact</div>
            <h2 className="mt-4 font-serif text-4xl font-light leading-tight sm:text-6xl">
              Ready to move.
              <br />
              <span className="italic text-[#D4AF37]">Whenever you are.</span>
            </h2>
            <p className="mt-6 max-w-lg text-base text-white/70">
              Start your confidential application, or call our concierge line to speak with a senior advisor directly.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link
                to="/apply"
                data-testid="contact-apply-btn"
                className="inline-flex items-center justify-center gap-3 border border-[#D4AF37] bg-[#D4AF37] px-8 py-4 text-xs uppercase tracking-[0.32em] text-[#050A1F] transition-colors hover:bg-[#F3E5AB]"
              >
                Fill Application <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href={PHONE_HREF}
                data-testid="contact-phone-btn"
                className="inline-flex items-center justify-center gap-3 border border-white/25 px-8 py-4 text-xs uppercase tracking-[0.32em] text-white transition-colors hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                <Phone className="h-4 w-4" /> {PHONE}
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="border border-white/10 bg-[#050A1F] p-8">
              <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Concierge Desk</div>
              <div className="mt-6 space-y-6 text-sm text-white/80">
                <div className="flex items-start gap-4">
                  <Phone className="mt-0.5 h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
                  <div>
                    <div className="text-white">Direct Line</div>
                    <div className="text-white/60">Mon – Sat · 8am – 8pm ET</div>
                    <a href={PHONE_HREF} className="mt-1 block font-serif text-2xl text-[#D4AF37]">
                      {PHONE}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Mail className="mt-0.5 h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
                  <div>
                    <div className="text-white">Email Support</div>
                    <div className="text-white/60">Replies within 2 business hours</div>
                    <a href={EMAIL_HREF} className="mt-1 block break-all font-serif text-xl text-[#D4AF37]">
                      {EMAIL}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <MapPin className="mt-0.5 h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
                  <div>
                    <div className="text-white">Headquarters</div>
                    <div className="text-white/60">1200 K Street NW, Suite 800<br />Washington, DC 20005</div>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Clock className="mt-0.5 h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
                  <div>
                    <div className="text-white">Median Response</div>
                    <div className="text-white/60">Under 2 business hours</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
